"use client";

import { CLink } from "@/components/common/customLink/CustomLink";
import HeaderEvents from "@/components/HeaderEvents";
import Navbar from "@/components/navbar/Navbar";
import ScrollToTop from "@/components/ScrollToTop";
import { Suspense, useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

interface IProps {
  error: Error & { digest?: string; statusCode?: number };
  reset: () => void;
}

const minimalHeaderContent = {
  id: "",
  type: "header",
  headerModules: [],
  menu: {
    enableImages: false,
    menu: [],
  },
  localeSelectorOverlay: null,
  enableAppleLogin: false,
  enableGoogleLogin: false,
  enableFacebookLogin: false,
  searchSection: {
    promotionalTiles: [],
    noResultSearchOverlay: {
      title: "",
      subTitle: "",
      edits: [],
    },
    noResultSearchPage: {
      title: "",
      subTitle: "",
      edits: [],
    },
  },
  magrabiLogo: "",
};

const Error = ({ error }: IProps) => {
  const errorCode = error.statusCode || 500;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <ScrollToTop />
      <Suspense>
        <HeaderEvents pageType="ERROR" />
      </Suspense>
      <Navbar
        headerContent={minimalHeaderContent}
        translation={{}}
        enableVto={false}
        socialMediaIcons={[]}
      />
      <main>
        <div className="container flex h-[75vh] flex-col items-center justify-center p-2">
          <p className="text-[2rem] font-semibold">{errorCode}</p>
          <p className="mt-6 text-center font-normal">
            Oops! Something went wrong. Please try again later.
          </p>
          <CLink
            href="/"
            className="mt-[2.625rem] flex h-[33px] items-center justify-center border-0 bg-black px-5 font-semibold text-white hover:opacity-70"
          >
            <span className="text-sm">Back to Homepage</span>
          </CLink>
        </div>
      </main>
    </>
  );
};

export default Error;
